import React from "react";

import styles from "./Actions.module.css";

import { useTableManagerContext } from "../../TableManagerContext";
import Button from "common-ui-components/components/button";
import { notify } from "common-ui-components/components/notification/Notification";
import { Failure } from "common-ui-components/components/notification/templates";

const Actions = () => {
  const { actionsConfig, selectOptions, filter } = useTableManagerContext();

  const { selectedRecords } = selectOptions;
  const handleOnClick = (onClick, disableOnNoSelection = false) => {
    if (disableOnNoSelection && selectedRecords.length === 0) {
      notify(<Failure>Please select a row to perform this action</Failure>);
    } else {
      onClick(selectedRecords);
    }
  };

  if (!actionsConfig) return null;

  return (
    <>
      {actionsConfig?.map((action) => {
        const isHidden =
          typeof action.hidden === "function"
            ? action.hidden({ selectedRecords, filter })
            : Boolean(action.hidden);

        if (isHidden) return null;

        return (
          <Button
            key={action.label}
            {...action.props}
            className={[
              styles.actionBtn,
              action.props?.className,
            ].join(" ")}
            onClick={() =>
              handleOnClick(action.props?.onClick, action.disableOnNoSelection)
            }
            variant={action.variant || action.props?.variant}
            disabled={
              (action.disableOnNoSelection && selectedRecords.length === 0) ||
              action.disabled || action.props?.disabled
            }
          >
            {action.label}
          </Button>
        );
      })}
    </>
  );
};

export default Actions;
